import React from "react";
import { Box, Paper, Typography, Avatar } from "@mui/material";
import { EmployeeProfile } from "../../../types/employee-details";

interface ProfileCardProps {
  profile: EmployeeProfile;
  imageUrl?: string;
}

const ProfileCard: React.FC<ProfileCardProps> = ({ profile, imageUrl }) => {
  const defaultImageUrl =
    "https://plus.unsplash.com/premium_photo-1689568126014-06fea9d5d341?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cHJvZmlsZXxlbnwwfHwwfHx8MA%3D%3D";

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        display: "flex",
        height:"100%",
        flexDirection: "column",
      }}
    >
      {/* Image */}
      <Box
        sx={{
          flexGrow: 1,
          position: "relative",
          background: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
        }}
      >
        {/* Main Image */}
        <Box
          component="img"
          src={imageUrl || defaultImageUrl}
          alt={profile.name}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 3,
          }}
          onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
            e.currentTarget.style.display = "none";
            const fallback = e.currentTarget.nextElementSibling as HTMLElement;
            if (fallback) fallback.style.display = "flex";
          }}
        />

        {/* Fallback Avatar */}
        <Avatar
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: "12px 12px 0 0",
            fontSize: "4rem",
            backgroundColor: "#424242",
            display: "none",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {profile.name.split(" ").map((n) => n[0]).join("")}
        </Avatar>

        <Paper
          elevation={0}
          sx={{
            position: "absolute",
            bottom: 16,
            left: 16,
            right: 16,
            p: 2,
            borderRadius: 2,
            bgcolor: "background.paper",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography variant="h6" fontWeight="600" sx={{ fontSize: "16px" }}>
              {profile.name}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ fontSize: "12px" }}>
              {profile.position}
            </Typography>
          </Box>
          <Box
            sx={{
              width: 50,
              height: 50,
              borderRadius: "50%",
              backgroundColor: "#2196F3",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontWeight: "bold",
              fontSize: "1.25rem",
            }}
          >
            {profile.pScore}
          </Box>
        </Paper>
      </Box>
    </Paper>
  );
};

export default ProfileCard;